// Components
import { Tooltip } from '@components';
import { EmptyList } from '@components/specific/emptyList/EmptyList';
import { Announcement, WaterAccountType } from '@types';

import { AnnouncementItem } from '../announcementItem/announcementItem';

import styles from './AnnouncementsList.module.scss';

export interface AnnouncementsListProps {
	waterAccount: WaterAccountType;
}

export const AnnouncementsList = ({ waterAccount }: AnnouncementsListProps) => {
	const emptyDisplay = (
		<div className={styles.content}>
			<EmptyList
				itemType="Announcement"
				itemOverwrittenName="Announcement"
				showContactLink={true}
			/>
		</div>
	);

	const announcements: Announcement[] = waterAccount.recentAnnouncedAllocations;

	const tooltipContent = (
		<div>
			The maximum volume of water you can take in a water year is calculated using the announced (%)
			multiplied by:
			<ul>
				<li>the nominal entitlement for water licences</li>
				<li>the volumetric limit for water allocations</li>
			</ul>
		</div>
	);

	return announcements.length > 0 ? (
		<div className={styles.wrapper} data-testid="announcementsList">
			<div className={styles[`water-account-list`]}>
				<table aria-label="announcements list">
					<thead>
						<tr
							className={styles[`water-account-list-header`]}
							aria-label="water account list - header"
							data-testid="tableHeader"
						>
							<th className={styles['columns_centered']}>Water Year</th>
							<th className={styles['columns_numeric']}>%</th>
							<th className={styles['columns_centered']}>Effective Date</th>
							<th>Authorisation Number</th>
							<th className={styles['columns_numeric']}>Volume</th>
							<th>
								<div className={styles['header_spaced']}>
									Max Volume
									<Tooltip
										customStyles={styles['title-tooltip']}
										title={'Maximum Volume'}
										htmltext={tooltipContent}
										id="announcement-max-volume-tooltip"
									/>
								</div>
							</th>
							<th>Status Reason</th>
						</tr>
					</thead>
					<tbody data-testid="announcementsTableBody">
						{announcements.map(announcement => (
							<AnnouncementItem
								announcement={announcement}
								key={announcement.announcedAllocationId}
							/>
						))}
					</tbody>
				</table>
			</div>
		</div>
	) : (
		emptyDisplay
	);
};
